import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MEDIUM_STALE_TIME } from "src/constants/query";
import { fetchHcfDetails } from "src/containers/facilityDrawer/billing/api";

export function useFacilityDetails(
  workplaceId: string,
  details: string[],
  options: { staleTime: number } = { staleTime: MEDIUM_STALE_TIME }
) {
  const queryClient = useQueryClient();
  const detailsString = details.join(",");
  const queryKey = ["workplaceUser-details", workplaceId, detailsString];
  const { staleTime } = options;

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => fetchHcfDetails(workplaceId, detailsString),
    staleTime,
  });

  const invalidateCache = () => {
    queryClient.removeQueries(queryKey);
  };

  return {
    data,
    isLoading,
    invalidateCache,
  };
}
